import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ClickToIdentifyState, MapClickInfo } from './types';

const initialState: ClickToIdentifyState = {
  mapClickInfo: null,
};

const clickToIdentifySlice = createSlice({
  name: 'clickToIdentify',
  initialState,
  reducers: {
    showMapClickInfo: (state, action: PayloadAction<MapClickInfo>) => {
      state.mapClickInfo = action.payload;
    },
    hideMapClickInfo: state => {
      state.mapClickInfo = null;
    },
  },
});

export const { showMapClickInfo, hideMapClickInfo } =
  clickToIdentifySlice.actions;

export default clickToIdentifySlice.reducer;
